import { render, staticRenderFns } from "./servicoCard.vue?vue&type=template&id=0820b7f3&"
import script from "./servicoCard.vue?vue&type=script&lang=js&"
export * from "./servicoCard.vue?vue&type=script&lang=js&"
import style0 from "./servicoCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports